import React, { forwardRef } from "react";
import cn from "classnames";
import styles from "./TextInput.module.sass";
import Icon from "../Icon";
import Tooltip from "../Tooltip";

const TextInput = forwardRef(
	(
		{
			className,
			classLabel,
			classInput,
			label,
			icon,
			copy,
			currency,
			tooltip,
			place,
			onChangeInput = () => {},
			togglePassword = () => {},
			passwordType,
			viewBox,
			textarea,
			...props
		},
		ref
	) => {
		return (
			<div
				className={cn(
					styles.field,
					{ [styles.fieldIcon]: icon },
					{ [styles.fieldCopy]: copy },
					{ [styles.fieldCurrency]: currency },
					className
				)}
			>
				{label && (
					<div className={cn(classLabel, styles.label)}>
						{label}{" "}
						{tooltip && (
							<Tooltip
								className={styles.tooltip}
								title={tooltip}
								icon="info"
								place={place ? place : "right"}
							/>
						)}
					</div>
				)}
				<div className={styles.wrap}>
					{textarea ? (
						<textarea
							className={cn(classInput, styles.input, styles.textarea)}
							{...props}
							onChange={(e) => {
								onChangeInput(e.target.value);
							}}
						/>
					) : (
						<input
							onWheel={(e) => {
								if (props.type === "number") e.target.blur();
							}}
							ref={ref}
							className={cn(classInput, styles.input)}
							{...props}
							onChange={(e) => {
								e.target.setCustomValidity("");
								onChangeInput(e.target.value);
							}}
						/>
					)}
					{icon && (
						<div className={styles.icon}>
							<Icon name={icon} size="24" viewBox={viewBox} />{" "}
						</div>
					)}
					{passwordType && (
						<div className={styles.passwordShow}>
							<button tabIndex="-1" type="button" onClick={togglePassword}>
								{passwordType === "password" ? (
									<Icon svgImage={"hideEye"} />
								) : (
									<Icon svgImage={"eye"} />
								)}
							</button>
						</div>
					)}
					{copy && (
						<button className={styles.copy}>
							<Icon name="copy" size="24" />{" "}
						</button>
					)}
					{currency && <div className={styles.currency}>{currency}</div>}
				</div>
			</div>
		);
	}
);

export default TextInput;
